const JS_TO_DAY = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
] as const;

const DAY_LETTERS = ['S', 'M', 'T', 'W', 'T', 'F', 'S'] as const;

export type ActiveWeekDay = {
  date: string;
  label: string;
  dayLetter: string;
  dayIndex: number;
};

/** Last N calendar days that fall on the user's activeDays (Mon on Monday shows rolling active history). */
export function getLastActiveDays(
  activeDays: string[],
  count = 7,
  anchor = new Date()
): ActiveWeekDay[] {
  const activeSet = new Set(
    (activeDays.length > 0 ? activeDays : JS_TO_DAY.slice(1, 6)).map((d) => d.toLowerCase())
  );

  const collected: Date[] = [];
  const cursor = new Date(anchor);
  cursor.setHours(12, 0, 0, 0);

  let safety = 0;
  while (collected.length < count && safety < 120) {
    const dayName = JS_TO_DAY[cursor.getDay()];
    if (activeSet.has(dayName)) {
      collected.unshift(new Date(cursor));
    }
    cursor.setDate(cursor.getDate() - 1);
    safety++;
  }

  return collected.map((d) => ({
    date: d.toLocaleDateString('en-CA'),
    label: d.toLocaleDateString('en-US', { weekday: 'short' }),
    dayLetter: DAY_LETTERS[d.getDay()],
    dayIndex: d.getDay(),
  }));
}

export function getActiveDayCount(activeDays: string[]): number {
  const set = new Set(activeDays.map((d) => d.toLowerCase()));
  return set.size > 0 ? set.size : 5;
}
